export default function Pitch() {
  return (
    <div className="hero-container-alt">
      <img src="/images/avp_logo.png" alt="Logo" className="hero-logo-small" />
      <div className="hero-text-pitch-small">DO YOU HAVE</div>
      <div className="hero-text-pitch"><span>STORIES</span><br></br> TO TELL?</div>
      <a className="hero-text-button" href="https://forms.gle/pwHYFWsEox9qwQvx5" target="_blank" rel="noreferrer" >PITCH HERE</a>
    </div>
  );
}